module.exports = __webpack_public_path__ + "static/media/LG 25+text_18sec.6e29ad28.mp3";